import { isArray } from 'util';
import { sortByString, mapCollection } from '../../utils/collection.utils';
import { ProductType } from '../product-type';

export class ProductTypeBuilder {

  static fromJson(json): ProductType {
    return (json) ? new ProductType(
      json.hash,
      json.name,
    ) : null;
  }

  static fromJsonList(list): ProductType[] {
    return (isArray(list)) ? sortByString('name', mapCollection(ProductTypeBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/product-type.builder.ts